export default {
	personal: {
		firstName: 'الاسم الأول',
		lastName: 'الكنية',
		nameInEnglish: 'الاسم الكامل بالانكليزي',
		fatherName: 'الاب',
		motherName: 'الام',
		sex: 'الجنس:',
		male: 'ذكر',
		female: 'انثى',
		nationality: 'الجنسية',
		birthday: 'الميلاد',
		age: 'العمر',
		birthLocation: 'مكان الولادة',
		state: 'المحافظة',
		nationalId: 'رقم الوطني',
	},

	societyStatus: {
		title: 'الحالة الاجتماعية',
		militaryability: 'الخدمة الإلزامية',
		marriageability: 'الحالة الاجتماعية',
		childNumber: 'عدد افراد الاسرة',
		marriageStatus: {
			marriage: 'متزوج',
			divorced: 'مطلق',
			single: 'أعزب',
		},
		militaryStatus: {
			done: 'مؤداة',
			exempt: 'معفى',
			postponed: 'مؤجل',
			postponedDate: 'تاريخ نهاية التأجيل',
			cause: 'السبب',
		},
	},

	other: 'معلومات إضافية',

	contactsInfo: {
		title: 'معلومات التواصل',
		contacts: 'التواصل',
		address: 'العنوان',
		phone: 'رقم الهاتف',
		mobile: 'رقم الهاتف المحمول',
		email: 'البريد الالكتروني',
		facebook: 'صفحة الفايسبوك',
		linkedin: 'صفحة لينكدان',
		instagram: 'صفحة انستجرام',
		addSocial: 'إضافة وسيلة تواصل',
	},

	healthInfo: {
		title: 'معلومات الصحية',
		haveIllness: 'هل تعاني من مرض؟',
		haveSurgery: 'هل أجريت عمليات جراحية؟',
		haveAllergy: 'هل عندك حساسية؟',
		smoking: 'هل انت مدخن؟',
		description: 'يرجى التوضيح',
	},

	validations: {
		nationalId: 'الرقم الوطني يجب ان يكون بين 10 و 14 خانة',
		militaryState: 'الحالة العسكرية للذكور فقط',
		mobilePhone: 'الرقم الجوال يجب ان يكون من 10 ارقام، ',
		mobileInvalid: 'الرقم غير صحيح، ',
	},

	addInformation: {
		addField: {
			title: 'إضافة حقل',
			button: 'إضافة حقل',
			name: 'اسم الحقل',
			type: 'نوع الحقل',
			types: {
				text: 'نص',
				date: 'تاريخ',
				radio: 'عدة اختيارات',
			},
			options: 'الاختيارات',
			optionsHind: 'يتم فصل الخيارات ب(-)',
		},
		addMedical: {
			title: 'إضافة سؤال',
			button: 'إضافة سؤال',
			question: 'السؤال',
			type: 'إضافة حقل توضيح عند',
			types: {
				onYes: 'عند إختيار نعم',
				onNo: 'عند اختيار لا',
				none: 'بدون',
			},
		},
	},
	'confirm-modification': 'تأكيد التعديل',
	'are-you-sure-you-want-to-save-the-modifications?': 'هل أنت متأكد من أنك تريد حفظ التعديلات ؟'
};
